import ExcludeBySuppressionListFilter from "../../components/filters/ExcludeBySuppressionListFilter/ExcludeBySuppressionListFilter";
import ExcludeBySuppressionListFilterResult from "../../components/filters/ExcludeBySuppressionListFilter/ExcludeBySuppressionListFilterResult";
import { leadsCapabilityMap } from "../../types/leadsCapability";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsDataSourceMap } from "../../types/leadsFilterBuildContext";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineLeadsFilter } from "../defineLeadsFilter";

import FindExcludeBySuppressionListFilter from "./ExcludeBySuppressionListFilter";

export const suppressionListIdsDefinition = defineLeadsFilter({
    key: "suppressionListIds",
    apiCategory: leadsFilterApiCategory.suppressionListIds,
    category: leadsFilterCategoryMap.exclude,
    trackingName: "Exclude websites in the suppression lists",
    titleKey: { key: "si.lead_gen_filters.excludeBySuppression.name" },
    requiresCapabilities: [leadsCapabilityMap.excludeFilters],
    requires: [leadsDataSourceMap.suppressionLists],
    // Only surfaces that default the full list on (see `render`) seed a value here; those must stay pending
    // until this filter can build, or the one-shot defaults seed would run without it. Surfaces that do not
    // default it carry no default, so they self-gate like any data-backed filter.
    seedsDefault: ({ applySuppressionListByDefault }) => applySuppressionListByDefault,

    render: ({ suppressionLists, applySuppressionListByDefault }) => ({
        tooltipText: { key: "si.lead_gen_filters.excludeBySuppression.tooltip" },
        filter: new FindExcludeBySuppressionListFilter({
            options: suppressionLists,
            initialDtoValue: applySuppressionListByDefault ? suppressionLists.map((s) => s.id) : undefined,
        }),
        filterView: ExcludeBySuppressionListFilter,
        filterResultView: ExcludeBySuppressionListFilterResult,
        affectsSearchDefinition: false,
    }),
});
